/**
 * Utility for generating scale ranges for Likert and NPS questions
 */
export class ScaleGenerator {
  static generateRange(min: number, max: number): number[] {
    const length = max - min + 1;
    return Array.from({ length }, (_, i) => min + i);
  }

  static getEffectiveMin(scaleMin: number | null | undefined, isNPS: boolean): number {
    if (scaleMin !== null && scaleMin !== undefined) {
      return scaleMin;
    }
    return isNPS ? 0 : 1;
  }

  static getEffectiveMax(scaleMax: number | null | undefined, isNPS: boolean): number {
    if (scaleMax !== null && scaleMax !== undefined) {
      return scaleMax;
    }
    return isNPS ? 10 : 5;
  }
}
